import { Spin } from 'antd';
import React, { Component } from 'react';
import Content from './Content';
import Header from './Header';
import NNWebSocket from './NNWebSocket';
import YWebSocket from "./yogiyo/YWebSocket";

class Layout extends Component {
  updateCallData = (data) => {
    if (this.mainComponent) this.mainComponent.updateCallData(data);
  };

  setMain = (value) => {
    this.mainComponent = value;
  };

  render() {
    return (
      <>
        <Header updateCallData={this.updateCallData} />
        <div
          id="loadingSpinner"
          style={{
            display: 'none',
            position: 'fixed',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0)',
            top: 0,
            left: 0,
            textAlign: 'center',
            zIndex: 99999,
            // pointerEvents: "none"
          }}>
          <Spin style={{ position: 'absolute', top: '50%', zIndex: 99999 }} />
        </div>
        <Content setMain={this.setMain} />
        <NNWebSocket />
      </>
    );
  }
}

export default Layout;
